export default __webpack_public_path__ + "static/media/G0355.34I-26181_-16025_0.1666262220000.67d7447a.jpg";